import { render } from "./BYOS.vue?vue&type=template&id=177cb758"
import script from "./BYOS.vue?vue&type=script&setup=true&lang=js"
export * from "./BYOS.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BYOS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "177cb758"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('177cb758', __exports__)) {
    api.reload('177cb758', __exports__)
  }
  
  module.hot.accept("./BYOS.vue?vue&type=template&id=177cb758", () => {
    api.rerender('177cb758', render)
  })

}


export default __exports__